import axios from "axios"
const requestDemo = data => {
  return axios({
    url: "https://backend.wersel.io/api/Form/Request_demo",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  }).then(response => response.data)
}
const contactRequest = data => {
  return axios({
    url: "https://backend.wersel.io/api/Form/Contact",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  }).then(response => response.data)
}
const productForm = data => {
  return axios({
    url: "https://backend.wersel.io/api/Form/product_form",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data,
  }).then(response => response.data)
}
export const requestService = {
  requestDemo,
  contactRequest,
  productForm,
}
